<app-alert></app-alert>
<app-downloading></app-downloading>
<router-outlet></router-outlet>
@if (!!maintenanceDialogOpened) {
  <app-maintenance-mode-alert [dateInfo]="dateInfo"
  (closeModal)="closeMaintenanceDialog()"></app-maintenance-mode-alert>
}